import { Component, Input, ViewChild, OnInit, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'itl-lightbox',
  templateUrl: './lightbox.modal.html',
  styleUrls: ['./lightbox.modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LightboxModal implements OnInit {
  @ViewChild('swiperRef', { static: true }) swiperElRef!: ElementRef;

  @Input() images: string[] = [];
  @Input() currentIndex = 0;

  public version: number;

  constructor(public _modalCtrl: ModalController) { }

  ngOnInit(): void {
    // Initial slide is handled via [initialSlide]
  }

  slideChanged(): void {
    const swiper = (this.swiperElRef.nativeElement as any).swiper;
    if (swiper) {
      const activeIndex = swiper.activeIndex;
      if (activeIndex < this.images.length) {
        this.currentIndex = activeIndex;
      }
    }
  }
}
